<template>
	<p class="text-gray-400"><slot/></p>
</template>
<script setup lang="ts"></script>